module.exports = __webpack_public_path__ + "b697d5443f91cfe22236892067c5632f.png";